import { makeCarousel } from './component/splide/splide'
import { MenuManager } from './component/front/front-helpers/MenuManager'
import {
  removeActiveClassFromOtherFilters,
  removeActiveClassFromOtherSolutions
} from './component/front/front-helpers/ConstructionModalFilter'

document.addEventListener('DOMContentLoaded', e => {
  // makeCarousel('.is-1-item-splide')
  makeCarousel('.is-3-item-splide', threeItemsConfig)
  ConstructionModalFilter()
  constructionModalClick()
  filterByOfferLine()
  MenuManager()
})

const threeItemsConfig = {
  perPage: 3,
  perMove: 1,
  autoPlay: true,
  gap: '.75rem',
  breakpoints: {
    475: {
      perPage: 1
    },
    640: {
      perPage: 2
    }
  }
}

const constructionModalClick = () => {
  document.querySelectorAll('.drop-down-modals').forEach(elem => {
    elem.addEventListener('click', e => {
      elem.parentElement.parentElement.classList.add('is-active')
    }, { passive: true })
  })
}

const ConstructionModalFilter = () => {
  document.addEventListener('click', e => {
    if (e.target.classList.contains('piece-filter') || e.target.parentElement.classList.contains('piece-filter')) {
      e.preventDefault()
      const target = e.target.classList.contains('piece-filter') ? e.target : e.target.parentElement
      if (!target.classList.contains('is-active')) {
        removeActiveClassFromOtherFilters()
        target.classList.add('is-active')
        document.querySelector('input[name="pieces"]').value = target.dataset.pieces
      }
    }
  }, { passive: true })
}

const filterByOfferLine = () => {
  document.addEventListener('click', e => {
    const solutionButton = checkParentElementForClass(e.target, 'is-solution', 1, 3)
    if (solutionButton) {
      if (solutionButton) {
        if (!solutionButton.classList.contains('is-active')) {
          removeActiveClassFromOtherSolutions()
          solutionButton.classList.add('is-active')
          if (solutionButton.hasAttribute('data-modalid')) {
            document.querySelector('input[name="constructionModal"]').value = solutionButton.dataset.modalid
          }
          if (solutionButton.hasAttribute('data-offerlineid')) {
            document.querySelector('input[name="offerLine"]').value = solutionButton.dataset.offerlineid
            document.querySelector('input[name="constructionModal"]').value = solutionButton.dataset.modalid
          }
        }
      }
    }
  }, { passive: true })
}

const checkParentElementForClass = (node, className, currentDepth, maxDepth) => {
  if (node.classList.contains(className)) {
    return node
  }

  if (currentDepth <= maxDepth) {
    return checkParentElementForClass(node.parentElement, className, currentDepth + 1, maxDepth)
  }
}
